import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "buttonIcons"]

  connect() {
    this.updateButtonIcons()
  }

  toggle(event) {
    const checkbox = event.currentTarget
    const selectAllCheckbox = this.checkboxTargets.find(cb => cb.dataset.dsp === "all")

    // Handle "Select all" special case
    if (checkbox.dataset.dsp === "all") {
      if (checkbox.checked) {
        // If "Select all" is checked, check all DSPs
        this.checkboxTargets.forEach(cb => {
          if (cb.dataset.dsp !== "all") {
            cb.checked = true
          }
        })
      } else {
        // If "Select all" is unchecked, uncheck all DSPs
        this.checkboxTargets.forEach(cb => {
          if (cb.dataset.dsp !== "all") {
            cb.checked = false
          }
        })
      }
    } else {
      // If any specific DSP is unchecked, uncheck "Select all"
      if (!checkbox.checked && selectAllCheckbox) {
        selectAllCheckbox.checked = false
      }

      // If all DSPs are checked, check "Select all"
      const allDspsChecked = this.checkboxTargets
        .filter(cb => cb.dataset.dsp !== "all")
        .every(cb => cb.checked)

      if (allDspsChecked && selectAllCheckbox) {
        selectAllCheckbox.checked = true
      }
    }

    this.updateButtonIcons()
  }

  updateButtonIcons() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked && cb.dataset.dsp !== "all")

    // Clear existing icons
    this.buttonIconsTarget.innerHTML = ""

    // Add icons for each checked DSP
    checkedBoxes.forEach(cb => {
      const icon = document.createElement("img")
      icon.src = cb.dataset.dspIcon
      icon.alt = cb.dataset.dspName
      icon.className = "h-5 w-5 object-contain"
      this.buttonIconsTarget.appendChild(icon)
    })
  }

  apply() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked && cb.dataset.dsp !== "all")
    const dspCodes = checkedBoxes.map(cb => cb.dataset.dsp)

    // Build URL with current params plus DSP codes
    const url = new URL(window.location.href)
    const currentParams = new URLSearchParams(url.search)

    // Remove existing DSP params
    currentParams.delete('dsps')
    currentParams.delete('dsps[]')

    // Add selected DSPs as array
    if (dspCodes.length > 0) {
      dspCodes.forEach(code => {
        currentParams.append('dsps[]', code)
      })
    }

    // Navigate to new URL
    window.location.href = `${url.pathname}?${currentParams.toString()}`
  }

  reset() {
    // Check all DSPs by default
    this.checkboxTargets.forEach(cb => {
      cb.checked = true
    })

    this.updateButtonIcons()
    this.apply()
  }
}
